module.exports = __webpack_public_path__ + "img/img1.14047e29.svg";